import React from 'react';
import BatteryAlerts from '../views/BatteryAlerts';
export default {
  objectType: 'locator',
  attrName: 'locator.batteryAlerts',
  renderer: (data, props, context) => {
    if (data.value) {
      return /*#__PURE__*/React.createElement(BatteryAlerts, {
        value: data.value
      });
    }
    return null;
  }
};